import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ZoneDInterventionPage.css';

function ZoneDInterventionPage() {
    const navigate = useNavigate();

    const handleRegionClick = (path) => {
        navigate(path);
    };

    return (
        <div className="zone-d-intervention-container">
            <h1>Zones d'Intervention</h1>
            <p>Sélectionnez un département dans la région parisienne pour plus de détails.</p>
            <div className="map-grid">
                <div
                    className="map-cell region-75"
                    onClick={() => handleRegionClick('/zone-d-intervention/75')}
                >
                    Paris (75)
                </div>
                <div
                    className="map-cell region-93"
                    onClick={() => handleRegionClick('/zone-d-intervention/93')}
                >
                    Seine-Saint-Denis (93)
                </div>
                <div
                    className="map-cell region-94"
                    onClick={() => handleRegionClick('/zone-d-intervention/94')}
                >
                    Val-de-Marne (94)
                </div>
                <div
                    className="map-cell region-77"
                    onClick={() => handleRegionClick('/zone-d-intervention/77')}
                >
                    Seine-et-Marne (77)
                </div>
                <div
                    className="map-cell region-91"
                    onClick={() => handleRegionClick('/zone-d-intervention/91')}
                >
                    Essonne (91)
                </div>
                <div
                    className="map-cell region-78"
                    onClick={() => handleRegionClick('/zone-d-intervention/78')}
                >
                    Yvelines (78)
                </div>
            </div>
        </div>
    );
}

export default ZoneDInterventionPage;
